"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = TextField;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const components_1 = require("../components");
const TextFieldBase_1 = require("./TextFieldBase");
const utils_1 = require("../utils");
function TextField(props) {
    const { disabled = false, readOnly = false, required, errorMsg, value = "", onBlur, onFocus, api, onEnter, onEscapeBubble, hideErrorMessage, ...otherProps } = props;
    const isDisabled = !!disabled;
    const isReadOnly = !!readOnly;
    const textFieldProps = {
        ...otherProps,
        isDisabled,
        isReadOnly,
        isRequired: required,
        validationState: errorMsg ? "invalid" : "valid",
        value,
    };
    const inputRef = (0, react_1.useRef)(null);
    const { labelProps, inputProps } = (0, react_aria_1.useTextField)({
        ...textFieldProps,
        onKeyDown: (e) => {
            var _a;
            if (e.key === "Enter") {
                (0, utils_1.maybeCall)(onEnter);
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
            else if (e.key === "Escape" && onEscapeBubble) {
                // Allow closing modals from within text fields...
                e.continuePropagation();
            }
        },
    }, inputRef);
    // Construct our TextFieldApi to give access to some imperative methods
    if (api) {
        api.current = {
            focus: () => inputRef.current && inputRef.current.focus(),
        };
    }
    return ((0, jsx_runtime_1.jsx)(TextFieldBase_1.TextFieldBase, { ...(0, react_aria_1.mergeProps)(textFieldProps, { onBlur, onFocus }), errorMsg: errorMsg, required: required, labelProps: labelProps, inputProps: inputProps, inputRef: inputRef, tooltip: (0, components_1.resolveTooltip)(disabled, undefined, readOnly), hideErrorMessage: hideErrorMessage }));
}
